import {Injectable} from "@angular/core";
import {Subject} from "rxjs/Subject";
import {Picture} from "../../model/picture";

@Injectable()
export class PhotoSwipeService {

  private pictureChangedSource = new Subject<string>();
  private pictureAddSource = new Subject<Picture>();

  private swipePictures:Picture[];
  public index:number = -1;

  public isOpened = false;

  public hasComment: boolean;

  pictureChange$ = this.pictureChangedSource.asObservable();
  pictureAdd$ = this.pictureAddSource.asObservable();

  changePictures(pictures:Picture[]) {
    this.swipePictures = pictures;

    this.pictureChangedSource.next('change');
  }

  addPictures(pictures:Picture[]) {
    if (this.isOpened) {
      for (let picture of pictures) {
        this.pictureAddSource.next(picture);
      }
    }
  }

  galleryClosed() {
    this.isOpened = false;
    this.pictureChangedSource.next('closed');
  }

  galleryAfterChange(index) {
    this.index = index;
    this.pictureChangedSource.next('afterChange');
  }

  galleryBeforeChange() {
    this.pictureChangedSource.next('beforeChange');
  }

  getCurrentPicture(): Picture {
    return this.swipePictures[this.index];
  }

  openGallery(pictures?:Picture[], openComment?: boolean, index?:number) {
    this.swipePictures = new Array();

    if (pictures != null) {
      this.swipePictures = pictures;
    }

    if(openComment!=null) {
      this.hasComment = openComment;
    } else {
      this.hasComment = true;
    }

    if (index != null) {
      this.index = index;
    } else {
      this.index = -1;
    }

    this.pictureChangedSource.next('open');
    this.isOpened = true;
  }

  getPictures(): Picture[] {
    return this.swipePictures;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/photoswipe/photo-swipe.service.ts